export default __webpack_public_path__ + "static/media/bpt-core.796c5cd0.png";